<!-- poor man's pie menu -->
<script>
    import Vue from "vue";

    export default {
        name: "PasswordRow",
        props: {
            creds: Object,
        },

        data() {
            return {
                showPass: false,
                showNotes: false,
            };
        },

        methods: {
            copyField(field) {
                this.$emit("onCopy", this.creds, field);
            },
            editPass() {
                this.$emit("onEdit", this.creds);
            },

            toggleNotes() {
                this.showNotes = !this.showNotes;
            },
        },
    };
</script>

<template>
    <div class="password-row">
        <div class="site-name">
            {{ creds.site }}
        </div>

        <button class="field" v-if="creds.login" @click="copyField('login')">
            <div class="contents">
                {{ creds.login }}
            </div>
            <div class="action">
                <i class="material-icons">content_copy</i>
            </div>
        </button>

        <button class="field" v-if="creds.pass" @click="copyField('pass')">
            <div class="contents">
                •••
            </div>

            <div class="action">
                <i class="material-icons">content_copy</i>
            </div>
        </button>

        <div class="field notes-field" v-if="creds.notes">
            <div class="contents">
                <button @click="toggleNotes">
                    <i class="material-icons notes-icon">notes</i>
                </button>

                <div v-if="showNotes" class="printout">
                    {{ creds.notes }}
                </div>
            </div>

            <button class="action" @click="toggleNotes">
                <i class="material-icons">{{ showNotes ? "visibility_off" : "visibility_on" }}</i>
            </button>
        </div>

        <div class="buttons">
            <button class="btn edit" @click.prevent.stop="editPass()">
                Edit
            </button>
        </div>
    </div>
</template>



<style lang="scss">
    .password-row {
        text-decoration: none;
        margin: 24px;
        padding: 24px;
        border: 2px solid transparent;
        font-size: 14px;
        display: flex;
        flex-direction: column;

        @media (max-width: $mobile-width-break) {
            padding: 0;
        }

        .site-name {
            margin: 12px 0;
            font-weight: 600;
        }

        .field {
            display: flex;
            background: #f6f6f6;
            border-radius: 3px;
            align-items: center;
            margin-bottom: 10px;
            color: $input;

            .contents {
                flex-grow: 1;
                text-align: left;
                padding: 15px 20px;
            }

            .action {
                color: #999;

                padding: 8px;
                margin: 5px;


                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: background 300ms ease-out, color 300ms ease-out;


                i {
                    width: 25px;
                    overflow: hidden;
                }
            }

            &:hover {
                .action {
                    background: #e6e6e6;
                    color: #333;
                }
            }

            &.notes-field {
                align-items: flex-start;
                .contents button {
                    display: block;
                    width: 100%;
                    text-align: left;
                }
                .action {
                    margin-top: 9px;
                }
                .printout {
                    margin-top: 10px;
                    max-width: 30em;
                    white-space: pre-line;
                }
            }
        }

        .buttons {
            text-align: right;
            margin-top: 5px;

            .btn.edit {
                border: 1px solid #aeaeae;
                width: 9em;
            }
        }
    }
</style>
